import { IApplicationState } from '../../types/redux';
import { getBanks } from './getBanks';

export const getHasBanks = (state: IApplicationState): boolean => {
  const banks = getBanks(state);

  return banks.length > 0;
};
